import { render, staticRenderFns } from "./ViewTemplatesSms.vue?vue&type=template&id=072ca324"
import script from "./ViewTemplatesSms.vue?vue&type=script&lang=js"
export * from "./ViewTemplatesSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports